/*
 *
 * SignupPage reducer
 *
 */

import { ContainerActions, ContainerState } from './types';

import ActionTypes from './constants';

export const initialState: ContainerState = {
  isCheckingEmail: false,
  validationEmailMessage: '',
  listSalesPIC: [],
  loading: false,
  saleTeams: [],
};

function signupPageReducer(state: ContainerState = initialState, action: ContainerActions) {
  switch (action.type) {
    case ActionTypes.RESET_DEFAULT_STATE:
      return initialState;
    case ActionTypes.CHECK_EMAIL_REQUEST:
      return {
        ...state,
        isCheckingEmail: true,
        validationEmailMessage: '',
      };
    case ActionTypes.CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        isCheckingEmail: false,
        validationEmailMessage: action.payload,
      };
    case ActionTypes.CHECK_EMAIL_FAILURE:
      return {
        ...state,
        isCheckingEmail: false,
        validationEmailMessage: action.payload,
      };
    case ActionTypes.GET_LIST_SALES_PIC_SUCCESS:
      return {
        ...state,
        listSalesPIC: action.payload,
      };
    case ActionTypes.SIGNUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ActionTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ActionTypes.SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ActionTypes.SET_SALE_TEAMS:
      return {
        ...state,
        saleTeams: action.payload,
      };
    default:
      return state;
  }
}

export default signupPageReducer;
